import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { InventoryCostsSummary } from '../../services/inventoryCostsApi';

const fmt = (n: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n);

const monthLabel = (yyyymm: string) => {
  const [y, m] = yyyymm.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleString('en-US', { month: 'short' });
};

export const MonthlySpendBar: React.FC<{ summary: InventoryCostsSummary }> = ({ summary }) => {
  const data = summary.spent_by_month.map((r) => ({
    month: monthLabel(r.month),
    amount: Number(r.amount),
  }));

  return (
    <div className="bg-white rounded-lg shadow border border-gray-200 p-4">
      <h3 className="text-lg font-medium mb-2">Monthly Spend — YTD</h3>
      {data.length === 0 ? (
        <p className="text-gray-500 text-sm py-12 text-center">No expenses logged this year.</p>
      ) : (
        <div style={{ width: '100%', height: 280 }}>
          <ResponsiveContainer>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={(v: number) => fmt(v)} />
              <Tooltip formatter={(v: number) => fmt(v)} />
              <Bar dataKey="amount" fill="#6366f1" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default MonthlySpendBar;
